import moment from 'moment';
import _ from 'lodash';

export const formatTime = (seconds = 0) => {
  if (seconds < 0) return '0:00';

  const time = moment()
    .startOf('day')
    .seconds(seconds);

  const stringFormat = _.inRange(time.hours(), 1, 23) ? 'h:mm:ss' : 'm:ss';

  return time.format(stringFormat);
};

export const formatDurationToSeconds = (str = '00:00') => {
  const p = str.split(':');
  let s = 0;
  let m = 1;

  while (p.length > 0) {
    s += m * parseInt(p.pop(), 10);
    m *= 60;
  }

  return s;
};
